import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FaTimes } from 'react-icons/fa';
import { types } from '../options';
import ProgressIndicator from './ProgressIndicator';
const style = css `
  padding: 25px;
  border-radius: 10px;
  pointer-events: all;
  min-height: 60px;
  position: relative;

  > button {
    position: absolute;
    right: 5px;
    top: 5px;
    border: none;
    background-color: transparent;
    color: white;
  }
`;
export default function AlertBlock(props) {
    const { offset, alert, onClose } = props;
    return (_jsxs("div", { css: style, style: {
            margin: offset,
            backgroundColor: alert.options.backgroundColor,
            color: alert.options.color,
        }, children: [_jsx("button", { type: "button", onClick: onClose, children: _jsx(FaTimes, {}) }), _jsx("span", { children: alert.message }), alert.options.type === types.PROGRESS_INDICATOR && _jsx(ProgressIndicator, {})] }, alert.id));
}
